{
  "success": "{{key}} successfully!",
  "error": "Error {{verb}} a {{noun}}!",
  "there-is-an": "there was an error, try again.",
  "order-created": "the order was created",
  "order-updated": "Order updated",
  "order-updating": "Updating order information..."
}
